import {useMemo} from '@wordpress/element';

const defaults = {motion: true, particles: true, tilt: true, countup: true};

export const useUiEffects = () =>
    useMemo(() => {
        let fromStorage = {};
        try {
            const raw = localStorage.getItem('epi_ui_effects');
            if (raw) fromStorage = JSON.parse(raw);
        } catch {
        }

        const merged = {...defaults, ...fromStorage};

        const set = (next) => {
            try {
                const current = {...merged, ...next};
                localStorage.setItem('epi_ui_effects', JSON.stringify(current));
            } catch {
            }
        };

        return Object.freeze({...merged, set});
    }, []);
